module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Two-Factor confirmation is required","code":"Code"},"zh":{"title":"需要雙因素確認","code":"代碼"},"kr":{"title":"2단계 확인이 필요합니다","code":"코드"}}')
  delete Component.options._Ctor
}
